import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Form, FormGroup, Label, Input, Button,
} from 'reactstrap';
import { Country } from '../shared/region';
import { DEMO_FILTER_CATEGORY, customSelectStyles, DEMO_FILTER_DATA } from '../../utils';

function DemoModal(props) {
  const {
    modal, hideModal, facebook, instagram, twitter, handleCountryChange, applyFilter,
    spotify, youtube, setFollowersData, renderListing, country, clearFilter, isDisabled,
  } = props;
  const { ageRange, ethnicity, gender } = DEMO_FILTER_DATA;
  return (
    <Modal isOpen={modal} className="modal-audience-demographics modal-dialog-centered">
      <ModalBody>
        <span
          className="icon icon-cross"
          onClick={hideModal}
        />
        <Form>
          <h2>Audience demographics</h2>
          <div className="input-wrapper input-col-4">
            <Label className="head-label">Minimum number of followers</Label>
            <FormGroup className="input-field demographic-input">
              <Label
                for="facebook"
              >
                Facebook
              </Label>
              <Input
                type="text"
                name="facebook"
                value={facebook}
                onChange={(e) => { setFollowersData('facebook', e); }}
              />
            </FormGroup>
            <FormGroup className="input-field demographic-input">
              <Label
                for="instagram"
              >
                Instagram
              </Label>
              <Input
                type="text"
                name="instagram"
                value={instagram}
                onChange={(e) => { setFollowersData('instagram', e); }}
              />
            </FormGroup>
            <FormGroup className="input-field demographic-input">
              <Label
                for="youtube"
              >
                Youtube
              </Label>
              <Input
                type="text"
                name="youtube"
                value={youtube}
                onChange={(e) => { setFollowersData('youtube', e); }}
              />
            </FormGroup>
            <FormGroup className="input-field demographic-input">
              <Label
                for="twitter"
              >
                Twitter
              </Label>
              <Input
                type="text"
                name="twitter"
                value={twitter}
                onChange={(e) => { setFollowersData('twitter', e); }}
              />
            </FormGroup>
            <FormGroup className="input-field demographic-input">
              <Label
                for="spotify"
              >
                Spotify
              </Label>
              <Input
                type="text"
                name="spotify"
                value={spotify}
                onChange={(e) => { setFollowersData('spotify', e); }}
              />
            </FormGroup>
          </div>
          <div className="input-wrapper input-col-6">
            <Label className="head-label">Audience age range</Label>
            {renderListing(ageRange, DEMO_FILTER_CATEGORY.AGE)}
          </div>
          <div className="input-wrapper input-col-auto">
            <Label className="head-label">Audience country</Label>
            <FormGroup className="input-field demographic-input w-100 mr-0">
              <Country
                className="reactSelect"
                styles={customSelectStyles}
                onChange={handleCountryChange}
                value={country}
                isMulti
              />
            </FormGroup>
          </div>
          <div className="input-wrapper input-col-auto">
            <Label className="head-label">Audience ethnicity</Label>
            {renderListing(ethnicity, DEMO_FILTER_CATEGORY.ETHNICITY)}
          </div>
          <div className="input-wrapper input-col-auto">
            <Label className="head-label">Audience gender</Label>
            {renderListing(gender, DEMO_FILTER_CATEGORY.GENDER)}
          </div>
          <div className="audience-btn-group">
            <span onClick={clearFilter}>Clear All</span>
            <Button
              color="accept"
              onClick={() => { applyFilter(); }}
              disabled={isDisabled}
            >
              Apply filter
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}

DemoModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  facebook: PropTypes.string.isRequired,
  instagram: PropTypes.string.isRequired,
  twitter: PropTypes.string.isRequired,
  spotify: PropTypes.string.isRequired,
  youtube: PropTypes.string.isRequired,
  setFollowersData: PropTypes.func.isRequired,
  renderListing: PropTypes.func.isRequired,
  handleCountryChange: PropTypes.func.isRequired,
  country: PropTypes.array,
  clearFilter: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

DemoModal.defaultProps = {
  country: null,
};

export default DemoModal;
